import axios from "axios";

export const contactUsApi = async (body) => {
  let data = JSON.stringify(body);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `https://branches-backend.cyberx-infosystem.us/api/v1/contact-us`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios
    .request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
      alert(response?.data?.message);
    })
    .catch((error) => {
      console.log(error);
    });
};
